<template lang="pug">
  v-card
    v-card-title
     h2.card-title {{ 'base.add_company' | translate }}
    v-card-content
      v-text-field(
        :focus="true"
        :label="$t('base.company_name_2')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="form.name")
    v-card-actions
      v-btn(
        @click="onCreate"
        :loading="loading")
        | {{ 'base.create' | translate }}
</template>

<script>
import { mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'CreateModal',

  data: () => ({
    form: {
      name: null
    },
    errors: {
      name: null
    },
    loading: false
  }),
  mixins: [formErrorsMixin],
  methods: {
    ...mapActions('companies', [
      'createCompany'
    ]),

    async onCreate () {
      this.loading = true
      const payload = {
        name: this.form.name
      }
      this.checkValidData()
      if (this.errors.name === null) {
        const error = await this.createCompany(payload)
        if (!error) {
          this.$emit('update')
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.incorrect_data'))
        }
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
      }
    }
  }
}
</script>
